import React from 'react'
import ReactDOM from 'react-dom'
import { Router } from 'react-router-dom'
import 'element-remove'
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import 'app/i18n'
import Apollo from 'app/Apollo'
import Theme from 'app/Theme'
import history from 'app/history'
import ReactWidgetErrorBoundary from '../ReactWidgetErrorBoundary'
import Footer from 'components/Footer'
import ReactWidgetStyleManager from 'app/ReactWidgetStyleManager'

// разместить этот элемент в том месте страницы, где нужен виджет
// <div id="page_footer">
// <script type="text/javascript" src="/sports/scripts/react-widgets/page_footer.js?1"></script>

// получаем элемент
const element = document.getElementById('page_footer');

if (element) {

  // рендер виджета в указанный элемент
  // Apollo и Theme обязетнльны для создания необходимых контекстов
  // если нужны другие контексты, добавьте их сюда же внутри темы, обернув в них свой компонент
  ReactDOM.render(
    (
      <ReactWidgetErrorBoundary>
        <Apollo>
          <Router {...{history}}>
            <ReactWidgetStyleManager widgetId={element.id}>
              <Theme contain_styles_in_css_id={element.id}>
                <Footer />
              </Theme>
            </ReactWidgetStyleManager>
          </Router>
        </Apollo>
      </ReactWidgetErrorBoundary>
    ),
    element
  )
}

